import Styled from 'styled-components';

const NoReviewsStyled = Styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = Styled.a`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #575757;
  padding: 10px 16px 8px 16px;
`;

const Text = Styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  padding-bottom: 24px;
  color: #575757;
`;

const HeaderMsg = Styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  padding: 16px;
  color: #575757;
`;

export default NoReviewsStyled;
export { NoReviewsStyled, Title, Text, HeaderMsg };
